import React, { FC, useCallback, useRef, useState, useImperativeHandle, forwardRef, Fragment } from "react";
import { isEmpty } from "lodash-es";
import { PlatformTypeForInterstitial, useFeedPostsQuery, useGetInterstitialsQuery } from "api";
import FeedLoader from "./FeedLoader";
import { LoadMoreLoader } from "components/LoadMoreLoader";
import ActivityComponent from "components/PostComponent/ActivityComponent";
import { NoDataFound } from "components/NoDataFound";
import NewPostPrompt from "./NewPostPrompt";
import { PostsContainer } from "components/PostComponent";
import SmartFeed from "features/smart-feed";
import { isMobile } from "react-device-detect";

const Activities = forwardRef((_, ref) => {
  console.log("Activities", {isMobile})
  const ids = new Set<string>();
  const observer = useRef<any>();
  const [end, setEnd] = useState(false);
  const { data: interstitials } = useGetInterstitialsQuery({ variables: { platformType: isMobile ? PlatformTypeForInterstitial.Mobile : PlatformTypeForInterstitial.Web } });
  const { data, fetchMore, loading, refetch, networkStatus, error } = useFeedPostsQuery({
    variables: { offset: 0, limit: 20 },
    notifyOnNetworkStatusChange: true
  });

  useImperativeHandle(ref, () => {
    return {
      refetch() {
        if (!loading) {
          refetch()
        }
      }
    };
  }, [loading]);

  const lastElement = useCallback((node) => {
    if (loading) return;
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !end) {
        fetchMore({
          variables: { offset: data?.getFeedPosts?.length },
        }).then(({ data }) => {
          if (isEmpty(data?.getFeedPosts || [])) {
            setEnd(true);
          }
        });
      }
    });
    if (node) observer.current.observe(node);
  },
    [end, setEnd, loading, fetchMore, data?.getFeedPosts]
  );

  if (loading && (isEmpty(data?.getFeedPosts) || networkStatus === 4)) return <FeedLoader />

  if (isEmpty(data?.getFeedPosts) || error) return <NoDataFound>No posts available</NoDataFound>
  const interstitialsObj = (interstitials?.getInterstitials || []).reduce((a, c) => ({ ...a, [c?.position as number]: c }), {});
  return (
    <>
      <PostsContainer>
        <NewPostPrompt refetch={refetch} date={data?.getFeedPosts?.[0]?.createdAt} />
        {data?.getFeedPosts?.map((activity, key, arr) => {
          const isFetchMore = (key + 1 === arr.length) && !loading && !end;
          if (ids.has(`${activity?.post?.postId}`)) {
            return <Fragment key={key}>
              {interstitialsObj?.[key] ? <SmartFeed data={interstitialsObj?.[key]} /> : null}
              <div key={key} ref={isFetchMore ? lastElement : null} />
            </Fragment>
          } else {
            ids.add(`${activity?.post?.postId}`);
            return (
              <Fragment key={key}>
                {interstitialsObj?.[key] ? <SmartFeed data={interstitialsObj?.[key]} /> : null}
                <ActivityComponent
                  key={activity?.activityId}
                  activity={activity}
                  ref={isFetchMore ? lastElement : null}
                />
              </Fragment>)
          }
        })}
      </PostsContainer>
      {
        loading
          ?
          <LoadMoreLoader />
          :
          end
            ?
            <NoDataFound>No more posts</NoDataFound>
            :
            null
      }

    </>
  );
})

export default Activities;
